import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="admin--rinsed-pos-migration-banner"
export default class extends Controller {
  static values = { cookieName: String };

  dismiss() {
    const expires = new Date();
    expires.setDate(expires.getDate() + 14);
    document.cookie = `${this.cookieNameValue}=true; path=/admin; expires=${expires.toUTCString()}; SameSite=Lax`;
    this.element.remove();
  }
}
